// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc7fe6b1","453":"cc6905c2","455":"a7d4bb89","977":"15e6a5aa"}[chunkId] + ".chunk.js";
};